import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import React from "react";

import { getDiscoveryApiClient } from "../api/discoveryApi/discoveryApi";
import { DownloadUrlFailedNotification } from "../components/common/notification.components";
import { notificationStore, NotificationType } from "../store/notification";

export const getMarketingContentAndPitchUrl = async (
    insightType: InsightType,
    contentId?: string,
    contentVersion?: string,
    fallbackUrl?: string,
): Promise<string> => {
    const isMarketingContentOrPitch =
        insightType === InsightType.MARKETING ||
        insightType === InsightType.PITCHED_CONTENT;

    if (isMarketingContentOrPitch && contentId && contentVersion) {
        try {
            const data = await (
                await getDiscoveryApiClient()
            ).getContentDownloadUrl(contentId, contentVersion);
            return data.downloadUrl!;
        } catch (error) {
            notificationStore
                .getState()
                .upsertNotification(
                    React.createElement(DownloadUrlFailedNotification),
                    NotificationType.ERROR,
                );
            throw error;
        }
    }

    return fallbackUrl ?? "";
};
